
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "aria-hidden": "true",
    "viewBox": "0 0 1024 1024",
    "id": "icon-mention-down"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M661.333333 298.666667v213.333333h225.834667a21.333333 21.333333 0 0 1 12.970667 4.394667l2.112 1.856a21.333333 21.333333 0 0 1 1.770666 28.16l-1.770666 2.005333-375.168 375.168a21.333333 21.333333 0 0 1-28.16 1.770667l-2.005334-1.770667L121.749333 548.416a21.333333 21.333333 0 0 1 12.586667-36.266667L136.853333 512H362.666667L362.666667 298.666667h298.666666zM618.666667 42.666667a42.666667 42.666667 0 0 1 42.666666 42.666666v128H362.666667V85.333333a42.666667 42.666667 0 0 1 42.666666-42.666666h213.333334z"
      }
    }
  ]
})
    }
  